import { Component, OnInit, Input } from '@angular/core';
import { skip, takeUntil } from 'rxjs/operators';
import { fromEvent, Subject } from 'rxjs';
import { Router } from '@angular/router';

import { CoreAPIService } from '@app/core/services/core-api.service';
import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';
import { StorageService } from '@app/core/services/storage.service';
import { AddOn } from '@app/sale-presentation/models/add-on.model';

@Component({
	selector: 'ui-popover-for-product',
	templateUrl: './popover-for-product.component.html',
	styleUrls: ['./popover-for-product.component.less'],
})
export class UIPopoverForProductComponent implements OnInit {
	@Input() option: AddOn;

	popoverExists: boolean = false;
	popoverShow: boolean = false;
	popoverDestroyed$: Subject<boolean> = new Subject<boolean>();
	enquiry_hash: string = this.configure_service.configure_data.meta.enquiry_hash;
	timeout: any;
	mode: 'vehicle' | 'enquiry' = 'vehicle';

	destroyed$: Subject<boolean> = new Subject<boolean>();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {SessionService} session_service
	 * @param {ConfigureService} configure_service
	 * @param {CoreAPIService} core_api_service
	 * @param {ModalService} modal_service
	 * @param {Router} router
	 * @param {StorageService} storage_service
	 * @param {HelperService} helper_service
	 */
	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private core_api_service: CoreAPIService,
		private router: Router,
		private storage_service: StorageService,
	) {}

	ngOnInit(): void {
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((params) => {
			this.enquiry_hash = params.meta.enquiry_hash;
		});
	}

	/**
	 * Toggles popover for user sub menu.
	 */
	onTogglePopover(event: MouseEvent): void {
		if (this.popoverExists) {
			this.setHide();
			return;
		}

		this.setShow();
	}

	/**
	 * Hides user popover sub menu.
	 */
	setHide(): void {
		clearTimeout(this.timeout);

		this.popoverShow = false;

		this.timeout = setTimeout(() => {
			this.popoverExists = false;
			this.popoverDestroyed$.next(true);
		}, 200);
	}

	/**
	 * Shows user popover sub menu.
	 */
	setShow(): void {
		clearTimeout(this.timeout);

		this.popoverExists = true;
		this.popoverDestroyed$.next(false);

		this.timeout = setTimeout(() => {
			this.popoverShow = true;
		});

		fromEvent(document, 'click')
			.pipe(skip(1))
			.pipe(takeUntil(this.popoverDestroyed$))
			.subscribe(() => {
				this.setHide();
			});
	}

	open(event: MouseEvent, link: string) {
		window.open(link, '_blank');
	}

	/**
	 * Destroys component and any open subscriptions. Destroys popover if open.
	 */
	ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.popoverDestroyed$.next(true);
	}
}
